import * as React from 'react'
import ActionButtons from '../../components/shared/Store/ActionButton/ActionButtons'
import { Container, Row } from 'reactstrap'
import {
  HLogo,
  ZTLogo,
  StoreIdBox,
  StoreTopBar,
  StoreTopBarContent
} from '../../components/shared/Store/StoreStyledComponents'
import { FormattedHTMLMessage } from 'react-intl'
import Store from 'api/models/Store'
import { useHistory } from 'react-router-dom'

interface Props {
  modalOpen: boolean,
  activeStore: Store,
  isZeroTouch: boolean,
  isMobile: boolean,
  toggleShareModal: (toggled: boolean) => void,
  onToggle: (toggled: boolean) => void,
}

export default function StoreViewTopBar({
  modalOpen,
  activeStore,
  isZeroTouch,
  isMobile,
  toggleShareModal,
  onToggle
}: Props) {
  const history = useHistory()
  return (
    <StoreTopBar modalopen={modalOpen}>
      <Container>
        <Row>
          <StoreTopBarContent
            xs={{ size: '12' }}
            sm={{ size: 12 }}
            lg={{ size: 12 }}
            xl={{ size: 10, offset: 1 }}
          >
            <div>
              {isZeroTouch
                ? <ZTLogo onClick={() => history.push('/')} />
                : <HLogo onClick={() => history.push('/')} />}
              <StoreIdBox>
                <FormattedHTMLMessage id='store.storeId' />
                <span className='font-weight-bold'>
                  {activeStore.getShortId()}
                </span>
              </StoreIdBox>
            </div>
            <div>
              {activeStore.getShortId() && isMobile && (
                <ActionButtons
                  storeFullId={activeStore._id}
                  storeName={activeStore.getName()}
                  storeId={activeStore.getShortId()}
                  toggleShareModal={toggleShareModal}
                  onToggle={onToggle}
                  isZeroTouch={isZeroTouch}
                  isMobile={isMobile}
                />
              )}
            </div>
          </StoreTopBarContent>
        </Row>
      </Container>
    </StoreTopBar>
  )
}
